import { ReactNode } from 'react';
import ExploreHeader from './ExploreHeader';
import Footer from './Footer';

interface ExploreLayoutProps {
  children: ReactNode;
}

const ExploreLayout = ({ children }: ExploreLayoutProps) => {
  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900 flex flex-col">
      <ExploreHeader />
      <main className="flex-1 w-full">
        <div className="min-h-full">
          {children}
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default ExploreLayout;